import * as React from "react"
const SvgShare = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17 22.714a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 14 19.714q0-.15.075-.7l-7.025-4.1a2.97 2.97 0 0 1-2.05.8 2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 2 12.714q0-1.25.875-2.125A2.9 2.9 0 0 1 5 9.714a2.97 2.97 0 0 1 2.05.8l7.025-4.1a1.7 1.7 0 0 1-.063-.337A5 5 0 0 1 14 5.714q0-1.25.875-2.125A2.9 2.9 0 0 1 17 2.714q1.25 0 2.125.875.875.876.875 2.125t-.875 2.125A2.9 2.9 0 0 1 17 8.714a2.97 2.97 0 0 1-2.05-.8l-7.025 4.1q.05.176.063.338a5 5 0 0 1-.001.725q-.012.162-.062.337l7.025 4.1a2.97 2.97 0 0 1 2.05-.8q1.25 0 2.125.875.875.876.875 2.125t-.875 2.125a2.9 2.9 0 0 1-2.125.875" />
  </svg>
)
export default SvgShare
